import { APARTMENT_GROUP, BUILDING } from '../../../utils/Constants';

const floorA = {
  A12_23_34_45: '62,311,378,311,376,423,228,425,228,478,62,478',
  A13_24_35_46: '130,481,427,479,423,759,130,759',
  A14_25_36_47: '425,478,622,479,624,759,425,756',
  A15_26_37_48: '622,479,820,478,819,757,622,757',
  A16_27_38_49:
    '524,313,524,424,715,426,717,475,822,479,820,246,710,248,710,314',
  A17_28_39_50:
    '819,248,931,249,931,315,1117,315,1117,426,924,426,922,480,820,480',
  A18_29_40_51: '820,479,1017,479,1017,757,820,757',
  A19_30_41_52: '1017,479,1216,479,1214,757,1017,758',
  A20_31_42_53: '1216,479,1412,479,1412,560,1504,560,1502,757,1216,757',
  A21_32_43_54: '1412,478,1806,478,1806,759,1504,759,1504,559,1411,557',
  A22_33_44_55:
    '1263,314,1263,424,1504,428,1507,477,1677,474,1677,336,1609,336,1609,314',
};

const floorB = {
  B09_19_29_39:
    '144,375,144,413,174,414,176,484,395,485,395,416,264,414,262,374',
  B20_30_40: '6,416,174,414,174,487,116,487,115,521,8,521',
  B11_21_31_41: '49,520,174,520,174,701,50,701',
  B12_22_32_42: '174,520,300,522,301,700,176,700',
  B13_23_33_43: '300,521,425,521,425,700,301,700',
  B14_24_34_44: '425,521,551,521,551,700,427,700',
  B15_24_34_44: '551,519,680,521,680,701,552,701',
  B16_26_36_46: '678,520,805,518,805,701,680,700',
  B17_27_37_47:
    '676,414,676,484,737,485,737,519,805,519,805,374,710,374,710,413',
  B18_28_38_48:
    '710,374,612,374,612,414,490,413,488,484,676,484,676,414,708,413',
  C13_25_37_49:
    '805,375,878,373,878,414,998,414,995,483,875,483,873,519,808,519',
  C14_26_38_50: '807,521,932,519,931,700,805,700',
  C15_27_39_51: '932,520,1060,520,1060,700,934,701',
  C16_28_40_52: '1060,521,1185,521,1183,702,1058,702',
  C17_29_41_53: '1185,521,1311,519,1311,700,1183,700',
  C18_30_42_54:
    '1090,414,1090,485,1243,485,1244,518,1311,519,1309,374,1207,374,1207,416',
  C19_31_43_55:
    '1412,373,1411,412,1499,414,1499,483,1377,487,1375,519,1311,517,1311,373',
  C20_32_44_56: '1311,521,1436,521,1436,700,1311,700',
  C21_33_45_57: '1436,521,1562,521,1562,700,1436,700',
  C22_34_46_58: '1562,522,1687,520,1687,700,1562,700',
  C23_35_47_59: '1687,520,1813,520,1813,700,1687,700',
  C24_36_48_60: '1592,413,1592,486,1746,488,1746,518,1855,520,1855,413',
};

export const areasA = [
  {
    building: BUILDING.A,
    floor: APARTMENT_GROUP.GROUND,
    coords:
      '815,584,815,536,288,760,184,708,154,719,100,689,103,714,67,728,69,755,217,838',
    apartments: [
      { name: 'A01', coords: '228,478,228,425,376,423,376,249,3,230,3,478' },
      { name: 'A02', coords: '5,480,425,478,425,758,5,758' },
      { name: 'A03', coords: '507,478,624,478,622,759,508,759' },
      { name: 'A04', coords: '625,478,820,479,819,759,624,759' },
      {
        name: 'A05',
        coords:
          '524,424,717,428,717,475,820,475,819,246,378,248,378,316,466,316,466,362,524,363',
      },
      {
        name: 'A06',
        coords:
          '822,480,924,482,924,426,1117,426,1119,361,1175,363,1177,317,1263,315,1263,249,819,248',
      },
      { name: 'A07', coords: '822,479,1017,478,1017,761,820,759' },
      { name: 'A08', coords: '1019,476,1131,478,1131,761,1017,760' },
      {
        name: 'A09',
        coords:
          '1216,478,1411,482,1411,561,1502,561,1504,693,1487,693,1487,759,1216,759',
      },
      {
        name: 'A10',
        coords:
          '1506,478,1412,478,1412,559,1502,561,1504,688,1487,689,1487,847,1555,847,1582,817,1612,795,1646,774,1679,759,1714,744,1753,734,1791,725,1826,722,1872,720,1914,725,1857,620,1836,515,1807,515,1806,478',
      },
      {
        name: 'A11',
        coords:
          '1263,424,1506,424,1506,479,1806,479,1807,516,1838,516,1899,370,1780,248,1263,248',
      },
    ],
  },
  {
    building: BUILDING.A,
    floor: APARTMENT_GROUP.FLOOR_ONE,
    coords:
      '812,538,815,526,839,513,839,497,970,445,971,430,281,709,178,662,147,674,93,645,96,689,154,719,184,708,286,759',
    apartments: [
      { name: 'A12', coords: floorA.A12_23_34_45 },
      { name: 'A13', coords: floorA.A13_24_35_46 },
      { name: 'A14', coords: floorA.A14_25_36_47 },
      { name: 'A15', coords: floorA.A15_26_37_48 },
      { name: 'A16', coords: floorA.A16_27_38_49 },
      { name: 'A17', coords: floorA.A17_28_39_50 },
      { name: 'A18', coords: floorA.A18_29_40_51 },
      { name: 'A19', coords: floorA.A19_30_41_52 },
      { name: 'A20', coords: floorA.A20_31_42_53 },
      { name: 'A21', coords: floorA.A21_32_43_54 },
      { name: 'A22', coords: floorA.A22_33_44_55 },
    ],
  },
  {
    building: BUILDING.A,
    floor: APARTMENT_GROUP.FLOOR_TWO,
    coords:
      '284,709,966,432,966,392,276,660,174,610,142,622,86,595,93,643,149,673,178,660',
    apartments: [
      { name: 'A23', coords: floorA.A12_23_34_45 },
      { name: 'A24', coords: floorA.A13_24_35_46 },
      { name: 'A25', coords: floorA.A14_25_36_47 },
      { name: 'A26', coords: floorA.A15_26_37_48 },
      { name: 'A27', coords: floorA.A16_27_38_49 },
      { name: 'A28', coords: floorA.A17_28_39_50 },
      { name: 'A29', coords: floorA.A18_29_40_51 },
      { name: 'A30', coords: floorA.A19_30_41_52 },
      { name: 'A31', coords: floorA.A20_31_42_53 },
      { name: 'A32', coords: floorA.A21_32_43_54 },
      { name: 'A33', coords: floorA.A22_33_44_55 },
    ],
  },
  {
    building: BUILDING.A,
    floor: APARTMENT_GROUP.FLOOR_THREE,
    coords:
      '276,660,968,392,968,349,271,609,169,563,137,575,79,548,86,595,145,622,174,610',
    apartments: [
      { name: 'A34', coords: floorA.A12_23_34_45 },
      { name: 'A35', coords: floorA.A13_24_35_46 },
      { name: 'A36', coords: floorA.A14_25_36_47 },
      { name: 'A37', coords: floorA.A15_26_37_48 },
      { name: 'A38', coords: floorA.A16_27_38_49 },
      { name: 'A39', coords: floorA.A17_28_39_50 },
      { name: 'A40', coords: floorA.A18_29_40_51 },
      { name: 'A41', coords: floorA.A19_30_41_52 },
      { name: 'A42', coords: floorA.A20_31_42_53 },
      { name: 'A43', coords: floorA.A21_32_43_54 },
      { name: 'A44', coords: floorA.A22_33_44_55 },
    ],
  },
  {
    building: BUILDING.A,
    floor: APARTMENT_GROUP.FLOOR_FOUR,
    coords:
      '271,608,968,350,966,307,264,557,159,511,128,521,72,494,79,547,137,575,167,563',
    apartments: [
      { name: 'A45', coords: floorA.A12_23_34_45 },
      { name: 'A46', coords: floorA.A13_24_35_46 },
      { name: 'A47', coords: floorA.A14_25_36_47 },
      { name: 'A48', coords: floorA.A15_26_37_48 },
      { name: 'A49', coords: floorA.A16_27_38_49 },
      { name: 'A50', coords: floorA.A17_28_39_50 },
      { name: 'A51', coords: floorA.A18_29_40_51 },
      { name: 'A52', coords: floorA.A19_30_41_52 },
      { name: 'A53', coords: floorA.A20_31_42_53 },
      { name: 'A54', coords: floorA.A21_32_43_54 },
      { name: 'A55', coords: floorA.A22_33_44_55 },
    ],
  },
  {
    building: BUILDING.A,
    floor: APARTMENT_GROUP.SUPERSTRUCTURE,
    coords:
      '968,307,946,298,944,276,866,254,815,270,805,275,578,347,505,323,495,327,496,337,437,356,483,375,188,471,118,439,118,454,101,459,103,483,264,558',
    apartments: [
      {
        name: 'A56',
        coords: '127,313,374,313,378,478,423,478,425,695,127,695',
      },
      {
        name: 'A57',
        coords: '425,480,522,480,520,314,820,312,819,695,425,695',
      },
      {
        name: 'A58',
        coords: '819,312,1119,314,1119,480,1214,476,1214,695,819,693',
      },
      {
        name: 'A59',
        coords:
          '1263,313,1261,475,1214,475,1214,695,1809,695,1809,478,1612,476,1612,313',
      },
    ],
  },
];

export const areasB = [
  {
    building: BUILDING.B,
    floor: APARTMENT_GROUP.GROUND,
    coords: '1056,849,1826,396,1830,361,1056,801,842,712,842,767',
    apartments: [
      {
        name: 'B01',
        coords: '174,416,395,416,395,484,240,485,240,519,174,519',
      },
      { name: 'B02', coords: '174,522,300,522,300,705,174,705' },
      { name: 'B03', coords: '300,522,425,522,427,705,300,705' },
      { name: 'B04', coords: '425,521,551,521,552,705,427,705' },
      { name: 'B05', coords: '551,521,678,521,678,706,552,706' },
      { name: 'B06', coords: '676,519,805,521,805,706,676,706' },
      {
        name: 'B07',
        coords: '678,419,676,485,736,487,737,521,805,521,805,417',
      },
      { name: 'B08', coords: '551,417,676,417,676,486,552,486' },
      {
        name: 'C01',
        coords: '808,417,932,415,932,487,873,485,873,521,808,517',
      },
      { name: 'C02', coords: '807,521,934,521,934,705,807,705' },
      { name: 'C03', coords: '934,521,1060,521,1060,705,934,705' },
      { name: 'C04', coords: '1060,521,1185,521,1185,705,1060,705' },
      { name: 'C05', coords: '1185,520,1311,520,1311,705,1185,706' },
      {
        name: 'C06',
        coords: '1090,417,1090,484,1243,488,1244,520,1311,520,1311,417',
      },
      {
        name: 'C07',
        coords: '1311,417,1436,417,1436,488,1375,486,1375,518,1311,518',
      },
      { name: 'C08', coords: '1311,522,1436,521,1436,705,1311,705' },
      { name: 'C09', coords: '1436,521,1562,521,1562,705,1436,705' },
      { name: 'C10', coords: '1562,521,1687,521,1687,705,1562,705' },
      {
        name: 'C11',
        coords: '1687,519,1813,521,1813,660,1806,660,1807,706,1687,706',
      },
      {
        name: 'C12',
        coords:
          '1592,414,1592,484,1745,485,1745,518,1813,519,1814,658,1806,657,1807,704,1887,706,1918,465,1862,465,1862,421,1813,421,1813,416',
      },
    ],
  },
  {
    building: BUILDING.B,
    floor: APARTMENT_GROUP.FLOOR_ONE,
    coords:
      '1056,802,1826,365,1833,324,1058,751,919,697,893,709,841,688,841,714',
    apartments: [
      { name: 'B09', coords: floorB.B09_19_29_39 },
      { name: 'B10', coords: '49,414,174,415,174,483,116,485,115,521,47,519'},
      { name: 'B11', coords: floorB.B11_21_31_41 },
      { name: 'B12', coords: floorB.B12_22_32_42 },
      { name: 'B13', coords: floorB.B13_23_33_43 },
      { name: 'B14', coords: floorB.B14_24_34_44 },
      { name: 'B15', coords: floorB.B15_24_34_44 },
      { name: 'B16', coords: floorB.B16_26_36_46 },
      { name: 'B17', coords: floorB.B17_27_37_47 },
      { name: 'B18', coords: floorB.B18_28_38_48 },
      { name: 'C13', coords: floorB.C13_25_37_49 },
      { name: 'C14', coords: floorB.C14_26_38_50 },
      { name: 'C15', coords: floorB.C15_27_39_51 },
      { name: 'C16', coords: floorB.C16_28_40_52 },
      { name: 'C17', coords: floorB.C17_29_41_53 },
      { name: 'C18', coords: floorB.C18_30_42_54 },
      { name: 'C19', coords: floorB.C19_31_43_55 },
      { name: 'C20', coords: floorB.C20_32_44_56 },
      { name: 'C21', coords: floorB.C21_33_45_57 },
      { name: 'C22', coords: floorB.C22_34_46_58 },
      { name: 'C23', coords: floorB.C23_35_47_59 },
      { name: 'C24', coords: floorB.C24_36_48_60 },
    ],
  },
  {
    building: BUILDING.B,
    floor: APARTMENT_GROUP.FLOOR_TWO,
    coords:
      '1058,751,1833,323,1838,286,1058,698,917,647,893,659,815,630,817,681,893,708,919,698',
    apartments: [
      { name: 'B19', coords: floorB.B09_19_29_39 },
      { name: 'B20', coords: floorB.B20_30_40 },
      { name: 'B21', coords: floorB.B11_21_31_41 },
      { name: 'B22', coords: floorB.B12_22_32_42 },
      { name: 'B23', coords: floorB.B13_23_33_43 },
      { name: 'B24', coords: floorB.B14_24_34_44 },
      { name: 'B25', coords: floorB.B15_24_34_44 },
      { name: 'B26', coords: floorB.B16_26_36_46 },
      { name: 'B27', coords: floorB.B17_27_37_47 },
      { name: 'B28', coords: floorB.B18_28_38_48 },
      { name: 'C25', coords: floorB.C13_25_37_49 },
      { name: 'C26', coords: floorB.C14_26_38_50 },
      { name: 'C27', coords: floorB.C15_27_39_51 },
      { name: 'C28', coords: floorB.C16_28_40_52 },
      { name: 'C29', coords: floorB.C17_29_41_53 },
      { name: 'C30', coords: floorB.C18_30_42_54 },
      { name: 'C31', coords: floorB.C19_31_43_55 },
      { name: 'C32', coords: floorB.C20_32_44_56 },
      { name: 'C33', coords: floorB.C21_33_45_57 },
      { name: 'C34', coords: floorB.C22_34_46_58 },
      { name: 'C35', coords: floorB.C23_35_47_59 },
      { name: 'C36', coords: floorB.C24_36_48_60 },
    ],
  },
  {
    building: BUILDING.B,
    floor: APARTMENT_GROUP.FLOOR_THREE,
    coords:
      '1058,698,1836,288,1843,247,1060,647,920,595,893,608,815,579,817,632,892,659,919,647',
    apartments: [
      { name: 'B29', coords: floorB.B09_19_29_39 },
      { name: 'B30', coords: floorB.B20_30_40 },
      { name: 'B31', coords: floorB.B11_21_31_41 },
      { name: 'B32', coords: floorB.B12_22_32_42 },
      { name: 'B33', coords: floorB.B13_23_33_43 },
      { name: 'B34', coords: floorB.B14_24_34_44 },
      { name: 'B35', coords: floorB.B15_24_34_44 },
      { name: 'B36', coords: floorB.B16_26_36_46 },
      { name: 'B37', coords: floorB.B17_27_37_47 },
      { name: 'B38', coords: floorB.B18_28_38_48 },
      { name: 'C37', coords: floorB.C13_25_37_49 },
      { name: 'C38', coords: floorB.C14_26_38_50 },
      { name: 'C39', coords: floorB.C15_27_39_51 },
      { name: 'C40', coords: floorB.C16_28_40_52 },
      { name: 'C41', coords: floorB.C17_29_41_53 },
      { name: 'C42', coords: floorB.C18_30_42_54 },
      { name: 'C43', coords: floorB.C19_31_43_55 },
      { name: 'C44', coords: floorB.C20_32_44_56 },
      { name: 'C45', coords: floorB.C21_33_45_57 },
      { name: 'C46', coords: floorB.C22_34_46_58 },
      { name: 'C47', coords: floorB.C23_35_47_59 },
      { name: 'C48', coords: floorB.C24_36_48_60 },
    ],
  },
  {
    building: BUILDING.B,
    floor: APARTMENT_GROUP.FLOOR_FOUR,
    coords:
      '1058,648,1843,249,1847,209,1060,590,920,543,895,554,815,526,815,582,893,609,920,597',
    apartments: [
      { name: 'B39', coords: floorB.B09_19_29_39 },
      { name: 'B40', coords: floorB.B20_30_40 },
      { name: 'B41', coords: floorB.B11_21_31_41 },
      { name: 'B42', coords: floorB.B12_22_32_42 },
      { name: 'B43', coords: floorB.B13_23_33_43 },
      { name: 'B44', coords: floorB.B14_24_34_44 },
      { name: 'B45', coords: floorB.B15_24_34_44 },
      { name: 'B46', coords: floorB.B16_26_36_46 },
      { name: 'B47', coords: floorB.B17_27_37_47 },
      { name: 'B48', coords: floorB.B18_28_38_48 },
      { name: 'C49', coords: floorB.C13_25_37_49 },
      { name: 'C50', coords: floorB.C14_26_38_50 },
      { name: 'C51', coords: floorB.C15_27_39_51 },
      { name: 'C52', coords: floorB.C16_28_40_52 },
      { name: 'C53', coords: floorB.C17_29_41_53 },
      { name: 'C54', coords: floorB.C18_30_42_54 },
      { name: 'C55', coords: floorB.C19_31_43_55 },
      { name: 'C56', coords: floorB.C20_32_44_56 },
      { name: 'C57', coords: floorB.C21_33_45_57 },
      { name: 'C58', coords: floorB.C22_34_46_58 },
      { name: 'C59', coords: floorB.C23_35_47_59 },
      { name: 'C60', coords: floorB.C24_36_48_60 },
    ],
  },
  {
    building: BUILDING.B,
    floor: APARTMENT_GROUP.SUPERSTRUCTURE,
    coords:
      '1060,590,1850,209,1823,202,1823,185,1772,175,1770,163,1755,161,1631,215,1545,198,1545,205,1516,215,1582,227,1582,237,1428,304,1338,283,1266,314,1365,341,1365,349,1119,458,993,420,992,437,839,498,839,517,815,526,893,554,919,543',
    apartments: [
      { name: 'B49', coords: '49,415,395,414,395,517,376,519,376,658,49,658' },
      { name: 'B50', coords: '376,521,551,521,551,660,376,660' },
      {
        name: 'B51',
        coords: '486,413,486,519,552,519,551,660,807,660,805,413',
      },
      {
        name: 'C61',
        coords: '805,413,998,414,998,519,1058,519,1058,660,807,660',
      },
      {
        name: 'C62',
        coords: '1090,414,1309,413,1309,658,1058,658,1058,519,1090,519',
      },
      {
        name: 'C63',
        coords: '1309,414,1500,414,1500,517,1562,519,1562,660,1311,658',
      },
      {
        name: 'C64',
        coords: '1562,518,1590,518,1592,413,1813,413,1814,659,1563,659',
      },
    ],
  },
];
